<template>
  <div class="wrappper box box_v">
    <!-- 头部标题 -->
    <div class="header-wrapper">
      <div class="left" @click="goback">
        <div class="iconfont icon-fanhui2" style="font-size:35px"></div>
      </div>
      <div class="header">{{header}}投票</div>
      <div class="newvote">
        <Button
          class="bkcc-btn"
          @click="submit"
          :loading="loading"
          :disabled="loading"
        >发布</Button>
      </div>
    </div>
    <div class="content">
      <Card>
        <div class="content-top">
          <div class="vote-detail">
            <Form :model="detailItem" :label-width="80">
              <FormItem label="投票标题">
                <Input v-model="detailItem.input" placeholder="请输入标题" style="width: 885px" />
              </FormItem>
              <FormItem label="截止时间">
                <row>
                  <i-col span="11">
                    <DatePicker
                      type="date"
                      placeholder="请选择日期"
                      v-model="detailItem.date"
                      style="width: 430px"
                    ></DatePicker>
                  </i-col>
                  <i-col span="11">
                    <TimePicker
                      type="time"
                      placeholder="请选择结束时间"
                      v-model="detailItem.time"
                      style="width: 440px;margin-left: 24px"
                    ></TimePicker>
                  </i-col>
                </row>
              </FormItem>
              <FormItem label="投票描述">
                <div class="add-con" v-if="editor" @click="showEditor">
                  <i class="iconfont icon-tianjiajiahaowubiankuang"></i>
                  <span>增加描述</span>
                </div>
                <editor-box-one
                  :content="detailItem.content"
                  @editorContent="activityContent"
                  v-else
                  style="width: 910px;display: inline-block"
                ></editor-box-one>
                <div class="cha" v-if="!editor" @click="closeEditor">
                  <i class="iconfont icon-shanchu"></i>
                </div>
              </FormItem>
              <FormItem label="权限设置">
                <RadioGroup v-model="detailItem.quanxian">
                  <Radio label>所有人可参与</Radio>
                  <Radio label="realname">仅实名认证用户可参与</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="隐私设置">
                <RadioGroup v-model="detailItem.secret">
                  <Radio label>投票所有人可见</Radio>
                  <Radio label="sqyzs">投票仅社工可见</Radio>
                </RadioGroup>
              </FormItem>
              <FormItem label="发布至">
                <CheckboxGroup v-model="apptype" @on-change="appChange">
                  <Checkbox label="先锋e家"></Checkbox>
                  <Checkbox label="民生通"></Checkbox>
                </CheckboxGroup>
              </FormItem>
              <FormItem label="同步至">
                <Select v-model="selName" multiple @on-change="selChange" style="width: 885px" placeholder="请选择，默认发布至全部">
                  <OptionGroup label="微社区" v-if="showSq">
                    <Option v-for="item in shequ" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </OptionGroup>
                  <OptionGroup label="微支部" v-if="showZb">
                    <Option v-for="item in zhibu" :value="item.id" :key="item.id">{{ item.name }}</Option>
                  </OptionGroup>
                </Select>
              </FormItem>
              <FormItem label="置顶">
                <div class="zhiding" @click="zhiding" style="font-size: 16px">
                  <span class="iconfont" :class="top?'icon-xuanzhong1':'icon-xuanzhongkuang'"></span>
                  <span style="margin-left: 10px">置顶本投票</span>
                </div>
              </FormItem>
            </Form>
          </div>
        </div>
        <div class="vote-select" style="width: 1000px">
          <Form :model="selectItem" :label-width="80">
            <FormItem label="投票方式">
              <RadioGroup v-model="selectItem.xuanxiang">
                <Radio label="1">单选</Radio>
                <Radio label="0">多选</Radio>
              </RadioGroup>
            </FormItem>
            <FormItem v-model="selectItem.select" label="选项">
              <p v-if="!selectItem.select.length" class="nosel">请添加选项</p>
              <div
                class="sel-con"
                v-for="(item,i) in selectItem.select"
                :key="i"
                @click="saveIndex(i)"
              >
                <p>选项{{i+1}}</p>
                <div class="box">
                  <div class="sel-dea box">
                    <input type="text" class="box_f1" v-model="item.title" placeholder="请输入" />
                    <upload-img
                      :imgArr="item.imgArr"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="60"
                      :imgWidth="50"
                      @delPic="delPic"
                      @saveImg="saveImg"
                      :isActive="isActive"
                    >
                      <div class="uploadbox">
                        <div class="iconfont icon-img add"></div>
                      </div>
                    </upload-img>
                  </div>
                  <div class="del box_f1">
                    <i class="iconfont icon-shanchu" @click="delSelect(index)"></i>
                  </div>
                </div>
                <div
                  class="add-con"
                  v-if="item.editor"
                  @click="showContent(i)"
                  style="margin-top: 20px"
                >
                  <i class="iconfont icon-tianjiajiahaowubiankuang"></i>
                  <span>增加描述</span>
                </div>
                <editor-box
                  :index="index+ ''"
                  :i="i"
                  :content="item.content"
                  @editorContent="selectContent"
                  v-else
                  style="width: 910px;display: inline-block;margin-top: 20px"
                ></editor-box>
                <div class="cha" v-if="!item.editor">
                  <i class="iconfont icon-shanchu"></i>
                </div>
              </div>
              <div class="add-con1" @click="addSelect">
                <i class="iconfont icon-tianjiajiahaowubiankuang"></i>
                <span>增加选项</span>
              </div>
            </FormItem>
          </Form>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import editorBox from "../../../components/editorBox";
import editorBoxOne from "../../../components/editorBoxOne";
import uploadImg from "../../../components/uploadImg";
export default {
  created() {
    this.getMiniShequ();
    this.getMiniZhibu();
    this.header = this.$route.query.id ? "编辑" : "新建";
  },
  mounted() {
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
      this.getOptions(this.$route.query.id);
    }
  },
  data() {
    return {
      detailItem: {
        input: "",
        date: "",
        time: "",
        content: "",
        quanxian: "",
        secret: "",
        zone: ""
      },
      selectItem: {
        xuanxiang: "1",
        select: [
          {
            imgArr: [],
            title: "",
            content: "",
            editor: true,
            isActive: false
          }
        ]
      },
      top: false,
      miniShequ: [],
      zhibu: [],
      shequ: [],
      selName: [],
      editor: true,
      imgNumber: 1,
      imgArr: [],
      fixedNumber: [5, 5],
      isActive: false,
      index: "",
      loading: false,
      status: "",
      header: "",
      apptype: [],
      showSq: false,
      showZb: false
    };
  },
  methods: {
    goback() {
      if (this.$route.query.id) {
        this.$router.push({
          name: "voteDetail",
          query: { id: this.$route.query.id }
        });
      } else {
        this.$router.push({ name: "votelist" });
      }
    },
    submit() {
      console.log(this.detailItem);
      console.log(this.selectItem);
      var data1 = this.detailItem;
      var data2 = this.selectItem;
      var date = data1.date;
      date = this.$util.FormatDate(date, "yyyy-MM-dd");
      var endDate = date + " " + data1.time;
      var optionList = data2.select.map(item => {
        return {
          headPicUrl: item.imgArr.length ? item.imgArr[0].path : "",
          message: item.title,
          context: item.content,
          id: item.id ? item.id : ""
        };
      });
      var data = {
        id: this.$route.query.id ? this.$route.query.id : "",
        title: data1.input,
        context: data1.content,
        isRadio: data2.xuanxiang,
        isTop: this.top ? 1 : 0,
        joinUserType: data1.quanxian,
        visibleAppType: data1.secret,
        endTime: endDate,
        zoneIdList: data1.zone,
        optionList
      };
      // return
      this.loading = true;
      //处理zoneIDlist
      if(!data.zoneIdList.length){
        if(this.apptype.length == 1){
          if(this.apptype[0] == '先锋e家'){
            data.zoneIdList = [-2]
          }else if(this.apptype[0] == '民生通'){
            data.zoneIdList = [-1]
          }
        }else if(this.apptype.length == 2){
          data.zoneIdList = []
        }else {
          this.$Message.warning('请选择要发布到的小程序')
          this.loading = false
          return
        }
      }

      //判断信息是否全部填写，如填写不全提示
      if (data.input == "" || data1.date == "" || data1.time == "") {
        this.$Message.warning("请完善投票信息");
        this.loading = false;
        return;
      }
      if (data.optionList.length < 2) {
        this.$Message.warning("发布投票最少需要两个选项");
        this.loading = false;
        return;
      }
      var titleList = optionList.map(item => {
        return item.message;
      });
      if (titleList.indexOf("") != -1) {
        this.$Message.warning(`请填写选项${titleList.indexOf("") + 1}的标题`);
        this.loading = false;
        return;
      }
      this.$post(this.urlobj.newVote, data)
        .then(res => {
          if (res.isSucceed) {
            this.loading = false;
            this.$Message.success("发布成功");
            this.$router.push({ name: "votelist" });
          }
        })
        .catch(e => {
          console.log("error");
          this.loading = false;
        });
    },
    getDetail(id) {
      var url = this.urlobj.voteDetail(id);
      this.$get(url).then(res => {
        if (res.isSucceed) {
          var resData = res.rows[0];
          var endTime = resData.endTime
            .substr(0, resData.endTime.length - 2)
            .split(" ");
          this.detailItem = {
            input: resData.title,
            date: new Date(endTime[0]),
            time: endTime[1],
            content: resData.context,
            quanxian: resData.joinUserType ? resData.joinUserType : "",
            secret: resData.visibleAppType
          };
          //判断是发布至微社区还是微支部
          if (resData.zoneList) {
            let id = resData.zoneList.map(item => {
              return item.zoneType;
            });
            // console.log(list)
            if(id.indexOf(1) != -1){
              console.log('sq')
              this.apptype.push('民生通')
              this.showSq = true
            }
            if(id.indexOf(2) != -1) {
              console.log('zb')
              this.apptype.push('先锋e家')
              this.showZb = true
            }

          }
          this.detailItem.zone = resData.zoneList
            ? resData.zoneList.map(item => {
                return item.zoneId;
              })
            : "";
          this.selName = resData.zoneList
            ? resData.zoneList.map(item => {
                return item.zoneId;
              })
            : "";
          console.log(this.selName)
          this.status = resData.status;
          this.editor = resData.context == "" ? true : false;
          this.top = resData.isTop == 1 ? true : false;
          this.selectItem.xuanxiang = resData.isRadio + "";
          console.log(this.detailItem);
          console.log(this.selectItem);
        } else {
          this.$Message.warning("加载失败，请重试");
        }
      });
    },
    getOptions(id) {
      var url = this.urlobj.optionDetail(id);
      this.$get(url).then(res => {
        if (res.isSucceed) {
          var list = res.rows.map(item => {
            return {
              title: item.message,
              editor: item.context == 1 ? false : true,
              isActive: item.headPicUrl ? false : true,
              imgArr:
                !item.headPicUrl || item.headPicUrl == ""
                  ? []
                  : [{ path: item.headPicUrl }],
              id: item.id,
              content: ""
            };
          });
          var idList = res.rows.map(item => {
            return item.id;
          });
          idList.forEach((item, index) => {
            var data2 = {
              comeId: item,
              comeType: 71
            };
            this.$get(this.urlobj.selDetail, data2).then(res2 => {
              this.index = index;
              list[index].content = res2.newPrimaryKeys.context;
              this.selectItem.select = list;
              // console.log(list);
            });
          });
        }
      });
    },
    activityContent(data) {
      this.detailItem.content = data;
    },
    zhiding() {
      this.top = !this.top;
    },
    getMiniShequ() {
      var url = this.urlobj.getOrg();
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        zoneType: 1
      };
      this.$get(url, data).then(res => {
        var list = res.rows.map(item => {
          return {
            name: item.zoneName,
            id: item.zoneId
          };
        });
        this.shequ = list;
        this.miniShequ = list;
        console.log(list);
      });
    },
    getMiniZhibu() {
      var url = this.urlobj.getOrg();
      var data = {
        communityId: this.$store.state.streetorcommunityid,
        zoneType: 2
      };
      this.$get(url, data).then(res => {
        var list = res.rows.map(item => {
          return {
            name: item.zoneName,
            id: item.zoneId
          };
        });
        this.zhibu = list;
        console.log(list);
      });
    },
    selChange(val) {
      console.log(this.selName);
      this.detailItem.zone = val;
    },
    showEditor() {
      this.editor = false;
    },
    closeEditor() {
      this.editor = true;
      this.detailItem.content = "";
    },
    delPic(data) {
      if (this.$route.query.id) {
        this.selectItem.select[this.index].imgArr = [];
        return;
      }
      //删除封面图
      var id = data.id;
      var url = this.urlobj.deletePic(id);
      this.$delete(url).then(res => {
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.selectItem.select[this.index].imgArr = [];
        }
      });
    },
    saveIndex(index) {
      console.log(index);
      this.index = index;
    },
    saveImg(data) {
      var item = this.selectItem.select;
      item[this.index].imgArr.splice(0, 1, data);
      item[this.index].isActive = true;
    },
    showContent(index) {
      var item = this.selectItem.select;
      item[index].editor = false;
    },
    closeContent(index) {
      var item = this.selectItem.select;
      item[index].editor = true;
      item[index].content = "";
    },
    selectContent(data) {
      debugger
      console.log(data)
      console.log(this.selectItem.select,this.index)
      var item = this.selectItem.select;
      item[this.index].content = data;
    },
    delSelect(index) {
      if (
        this.$route.query.id &&
        index <= this.selectItem.select.length &&
        this.status == 1
      ) {
        this.$Message.warning("已开始的投票不能删除选项");
        return;
      }
      var item = this.selectItem.select;
      item.splice(index, 1);
    },
    addSelect() {
      var item = {
        imgArr: [],
        title: "",
        content: "",
        editor: true,
        isActive: false
      };
      this.selectItem.select.push(item);
    },
    appChange(val) {
      if (val.length == 1) {
        if (val[0] == "民生通") {
          this.showSq = true;
          this.showZb = false;
          this.selName.forEach((item, index) => {
            this.zhibu.forEach(_item => {
              if(item == _item.id) {
                this.selName.splice(index, 1)
              }
            })
          })
        } else {
          this.showSq = false;
          this.showZb = true;
          this.selName.forEach((item, index) => {
            this.shequ.forEach(_item => {
              if(item == _item.id) {
                this.selName.splice(index, 1)
              }
            })
          })
        }
      } else if (val.length == 2) {
        this.showSq = true;
        this.showZb = true;
      } else {
        this.showZb = false;
        this.showSq = false;
        this.selName = []
      }
    }
  },
  components: {
    editorBox,
    editorBoxOne,
    uploadImg
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  color: #666666;
  overflow: hidden;
  height: 100%;
  // font-size: 16px;
}
.header-wrapper {
  display: flex;
  justify-content: center;
  height: 84px;
  line-height: 84px;
  position: relative;
}
.header {
  font-size: 25px;
  text-align: center;
}
.left {
  position: absolute;
  left: 20px;
  font-size: 22px;
}
.newvote {
  position: absolute;
  right: 20px;
}
.content {
  // max-width: 96%;
  margin: 20px;
}
.add-con {
  font-size: 16px;
  color: #999;
  border: 1px dashed #ddd;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  padding: 0 5px;
  margin-left: 8px;
}
.cha {
  display: inline-block;
  margin-left: 10px;
  width: 0;
  color: #d42b2b;
}
.vote-detail {
  width: 1000px;
  margin: 0 auto;
}
.vote-select {
  margin: 0 auto;
  margin-top: 20px;
}
.content-top {
  border-bottom: 1px solid #ddd;
}
.icon-xuanzhong1 {
  color: #fe7d43;
}
/deep/ .ivu-input {
  font-size: 16px;
}
/deep/ .ivu-form-item-label {
  font-size: 16px;
}
/deep/ .ivu-radio-wrapper {
  font-size: 16px;
  color: #999;
}
.sel-dea {
  border: 1px solid #ddd;
  border-radius: 2px;
  padding: 10px;
  width: 510px;
}
.del {
  margin: auto;
  margin-left: 10px;
  color: #d42b2b;
}
.add-con1 {
  font-size: 16px;
  color: #ff7c43;
  border: 1px solid #ff7c43;
  width: 100px;
  height: 30px;
  line-height: 30px;
  border-radius: 5px;
  padding: 0 5px;
  margin-top: 20px;
  margin-left: 8px;
}
.nosel {
  font-size: 16px;
  color: #999;
}
/deep/ label {
  margin-right: 8px;
}
.zhiding {
  margin-top: 2px;
}
/deep/ .ivu-checkbox-group-item {
  font-size: 16px;
  color: #999
}
</style>

